import React from 'react';
import { OperatorSelector } from './OperatorSelector';
import { ValueSelector } from './ValueSelector';
import { FilterColumnProps } from './types';

export function FilterColumnRow(props: FilterColumnProps) {
  return (
    <div className="flex items-center gap-2 w-full">
        {props.useOperatorSelector && <OperatorSelector
          {...props}
        />}
        <ValueSelector
          {...props}
        />
    </div>
  );
    }